module.exports = __webpack_public_path__ + "img/shenp.18e941a5.jpg";